import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmoteStreamType } from '../redux/types';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { streamTypeToSearchType } from '../constants';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { useTabHotkeys } from './hotkeys';
import TabButton from './TabButton';
import s from './TabsHeader.scss';
const tabOrder = [
    EmoteStreamType.OFFICIAL,
    EmoteStreamType.COMMUNITY,
    EmoteStreamType.USER
];
function getTabTranslation(t, tab) {
    switch(tab){
        case EmoteStreamType.OFFICIAL:
            return t('emoteselector.official');
        case EmoteStreamType.COMMUNITY:
            return t('emoteselector.community');
        case EmoteStreamType.USER:
            return t('emoteselector.user');
        default:
            return '';
    }
}
const TabsHeader = ({ activeStream , switchStream , onOpenSearch  })=>{
    const { t  } = useTranslation();
    const { focusedTabIndex , setFocusedTabIndex , clearFocusedTabIndex , onKeyDown  } = useTabHotkeys(tabOrder.length);
    const handleSwitchTab = (streamType)=>{
        switchStream({
            streamType,
            searchType: streamTypeToSearchType[streamType],
            searchQuery: ''
        });
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        role: "tablist",
        className: s['tabs']
    }, tabOrder.map((tab, index)=>/*#__PURE__*/ React.createElement(TabButton, {
            key: `emote-tab-${tab}-${index}`,
            tab: tab,
            onClick: handleSwitchTab,
            isActive: activeStream === tab,
            // We only want the active item to be in the tab order,
            // we'll focus the rest manually
            tabIndex: activeStream === tab ? 0 : -1,
            focused: index === focusedTabIndex,
            onFocus: ()=>focusedTabIndex !== index && setFocusedTabIndex(index),
            onBlur: ()=>focusedTabIndex === index && clearFocusedTabIndex(),
            onKeyDown: onKeyDown
        }, getTabTranslation(t, tab)))), /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        onClick: onOpenSearch,
        className: s['tab']
    }, /*#__PURE__*/ React.createElement(SearchIcon, {
        size: IconSize.SMALL,
        className: s['search-icon'],
        disableDefaultColors: true
    })));
};
TabsHeader.displayName = 'TabsHeader';
export default TabsHeader;
